import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import home from '@/components/home'
import aboutUs from '@/components/aboutUs'
import newsCenter from '@/components/newsCenter'
import investor from '@/components/investor'
import contactUs from '@/components/contactUs'
import vocational from '@/components/vocational'
import construct from '@/components/construct'
import search from '@/components/search'
import copyright from '@/components/copyright'
import detail from '@/components/detail'


Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'main',
		component: main,
		redirect: "/home",
		children: [{
				path: '/home',
				component: home,
			},
			{
				path: '/aboutUs',
				component: aboutUs,
			},
			{
				path: '/newsCenter',
				component: newsCenter,
			},
			{
				path: '/investor',
				component: investor,
			},
			{
				path: '/contactUs',
				component: contactUs,
			},
			{
				path: '/vocational',
				component: vocational,
			},
			{
				path: '/search',
				component: search,
			},
			{
				path: '/copyright',
				name: 'copyright',
				component: copyright,
			},
			{
				path: '/construct',
				name: 'construct',
				component: construct,
			},
			{
				path: '/detail',
				name: 'detail',
				component: detail,
			},
		]
	}, ],
	scrollBehavior(to, from, saveTop) {
		// console.log(to, from);
		// saveTop = saveTop || to.meta.saveTop
		return {
			x: 0,
			y: 0,
		};
	},
})

const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;

Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js